import { log } from '../tracking/InternalLogger';
import { detectFormTest } from '../helpers/detect-form-test';
const whitePaperDownloadResultCallback = async (callbackData) => {
    log('Form submit result', {
        formName: 'Whitepaper download',
        status: callbackData.xhr.status,
        isTest: detectFormTest(callbackData.data),
    });
    try {
        const isSuccess = callbackData.xhr.status >= 200 && callbackData.xhr.status < 300;
        const fileDownload = callbackData.formContainer.dataset.fileDownload || 'undefined';
        if (isSuccess && fileDownload !== 'undefined') {
            const pdfUrl = fileDownload;
            const downloadLink = document.querySelector('a.download-link');
            if (downloadLink !== null) {
                downloadLink.href = pdfUrl;
                downloadLink.click();
            }
        }
        return true;
    }
    catch (error) {
        console.error('Error in whitePaperDownloadResultCallback:', error);
        throw error;
    }
};
export const whitePaperDownloadCallbacks = {
    whitePaperDownloadResultCallback,
};
